// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-button{border:0;background:0;padding:0;margin:0;margin-left:10px;position:relative;top:5px;outline:0}.help-button:disabled{background-color:rgba(0,0,0,0)}", ""]);
// Exports
module.exports = exports;
